export class RawTableQueryBuilder {
    constructor(rawTableQuery) {
        this.rawTableQuery = rawTableQuery;
    }

    build(context) {
        return this.rawTableQuery;
    }
}
